/** Fields required on the partner public profile before admin can verify. */

export type PartnerProfileCompletenessInput = {
  institution_name?: string | null;
  mission?: string | null;
  history?: string | null;
  website?: string | null;
  country?: string | null;
  locations?: string[] | string | null;
  avatar_url?: string | null;
  logo_url?: string | null;
};

function filled(value?: string | null): boolean {
  return Boolean(value && value.trim().length > 0);
}

function locationCount(locations?: string[] | string | null): number {
  if (Array.isArray(locations)) {
    return locations.map((l) => l.trim()).filter(Boolean).length;
  }
  if (typeof locations === "string") {
    return locations
      .split(",")
      .map((l) => l.trim())
      .filter(Boolean).length;
  }
  return 0;
}

export function getPartnerProfileMissingFields(
  profile: PartnerProfileCompletenessInput | null | undefined,
): string[] {
  if (!profile) {
    return [
      "Institution name",
      "Logo",
      "Country",
      "Website",
      "Mission",
      "History",
      "Locations",
    ];
  }

  const missing: string[] = [];
  if (!filled(profile.institution_name)) missing.push("Institution name");
  if (!filled(profile.avatar_url) && !filled(profile.logo_url)) missing.push("Logo");
  if (!filled(profile.country)) missing.push("Country");
  if (!filled(profile.website)) missing.push("Website");
  if (!filled(profile.mission)) missing.push("Mission");
  if (!filled(profile.history)) missing.push("History");
  if (locationCount(profile.locations) < 1) missing.push("Locations");
  return missing;
}

export function isPartnerProfileComplete(
  profile: PartnerProfileCompletenessInput | null | undefined,
): boolean {
  return getPartnerProfileMissingFields(profile).length === 0;
}
